import { exec } from '../utils';
import type {
  BadgeCredentials,
  BadgeAuthenticationArgs,
  BadgeAuthenticationExecVariables,
  BadgeAuthenticationExecResponse
} from '@src/types';

/**
 * Initiates the badge authentication flow.
 * Additional authentication methods will be supported in the future.
 */
export const badgeAuthentication = async ({ username }: BadgeAuthenticationArgs): Promise<BadgeCredentials> => {
  const query = `
    mutation badgeAuthentication(
      $username: String!
      $adminAuth: Boolean
      $adminTokenTtl: Int
    ) {
      authenticate(username: $username, adminAuth: $adminAuth, adminTokenTtl: $adminTokenTtl) {
        oneTimeToken
        uuid
        name
        email
        token
      }
    }
  `;

  const data = await exec<BadgeAuthenticationExecVariables, BadgeAuthenticationExecResponse>(
    query, {
      variables: {
        username,
        adminAuth: true,
        adminTokenTtl: 3600,
      },
    },
  );

  return data.authenticate;
};
